import { Text, View } from "@react-pdf/renderer";
import { payments } from "lobbie";
import styles, { pdfColors } from "../base/styles";
import InvoiceLineItem from "./InvoiceLineItem";

interface IProps {
    services: payments.print.IInvoiceLineItem[];
    items: payments.print.IInvoiceLineItem[];
    applyTax: boolean;
    hasSubscription: boolean;
    isReceipt: boolean;
}

const InvoicePageContent: React.FC<IProps> = ({
    services,
    items,
    applyTax,
    hasSubscription,
    isReceipt,
}) => {
    return (
        <View id="invoice-content" style={[styles.pt8]} fixed>
            {services.length > 0 && (
                <View id="services-table" style={[styles.row, styles.w100, styles.pb8]}>
                    <View id="table-title" style={[styles.col, styles.w100]}>
                        <Text
                            style={[
                                styles.textBlack,
                                styles.textH3,
                                styles.textBold,
                                styles.pt8,
                                styles.pb4,
                            ]}
                        >
                            Services
                        </Text>
                        <View
                            style={[
                                styles.row,
                                styles.w100,
                                styles.pb4,
                                styles.pt6,
                                styles.justBetween,
                                { borderBottom: "0.5px", borderBottomColor: pdfColors.Gray20 },
                            ]}
                        >
                            <View
                                style={[
                                    styles.row,
                                    styles.textGray65,
                                    styles.textBold,
                                    { gap: "12px" },
                                ]}
                            >
                                <View style={[{ width: "150px", alignItems: "flex-start" }]}>
                                    <Text>{"Service"}</Text>
                                </View>
                                <View style={[{ width: "60px", alignItems: "flex-start" }]}>
                                    <Text>{"Code:"}</Text>
                                </View>
                                <View style={[{ width: "60px", alignItems: "flex-start" }]}>
                                    <Text>{`${hasSubscription && !isReceipt ? "Start Date:" : ""}`}</Text>
                                </View>
                            </View>

                            <View
                                style={[
                                    styles.row,
                                    styles.textGray65,
                                    styles.textBold,
                                    { gap: "12px" },
                                ]}
                            >
                                <View style={[{ width: "50px", alignItems: "flex-end" }]}>
                                    <Text>Qty</Text>
                                </View>
                                <View style={[{ width: "50px", alignItems: "flex-end" }]}>
                                    <Text>Charge</Text>
                                </View>
                                {applyTax && (
                                    <View style={[{ width: "30px", alignItems: "flex-end" }]}>
                                        <Text>Tax</Text>
                                    </View>
                                )}
                                <View style={[{ width: "55px", alignItems: "flex-end" }]}>
                                    <Text>{applyTax ? "Subtotal" : "Total"}</Text>
                                </View>
                            </View>
                        </View>
                        {services.map((service) => {
                            if (!(isReceipt && !!service.serviceRecurrenceType)) {
                                return (
                                    <InvoiceLineItem
                                        key={service.careResourceId}
                                        charge={service}
                                        taxRate={service.taxRate}
                                        applyTax={applyTax}
                                    />
                                );
                            }
                        })}
                    </View>
                </View>
            )}
            {items.length > 0 && (
                <View id="items-table-container" style={[styles.pt8]} fixed>
                    <View id="items-table" style={[styles.row, styles.w100, styles.pb8]}>
                        <View id="table-title" style={[styles.col, styles.w100]}>
                            <Text
                                style={[
                                    styles.textBlack,
                                    styles.textH3,
                                    styles.textBold,
                                    styles.pt8,
                                    styles.pb4,
                                ]}
                            >
                                Items
                            </Text>
                            <View
                                style={[
                                    styles.row,
                                    styles.w100,
                                    styles.pb4,
                                    styles.pt6,
                                    styles.justBetween,
                                    { borderBottom: "0.5px", borderBottomColor: pdfColors.Gray20 },
                                ]}
                            >
                                <View
                                    style={[
                                        styles.row,
                                        styles.textGray65,
                                        styles.textBold,
                                        { gap: "12px" },
                                    ]}
                                >
                                    <View style={[{ width: "150px", alignItems: "flex-start" }]}>
                                        <Text>{"Item"}</Text>
                                    </View>
                                    <View style={[{ width: "60px", alignItems: "flex-start" }]}>
                                        <Text>{"Code:"}</Text>
                                    </View>
                                    <View style={[{ width: "60px", alignItems: "flex-start" }]}>
                                        <Text>{""}</Text>
                                    </View>
                                </View>

                                <View
                                    style={[
                                        styles.row,
                                        styles.textGray65,
                                        styles.textBold,
                                        { gap: 12 },
                                    ]}
                                >
                                    <View style={[{ width: "50px", alignItems: "flex-end" }]}>
                                        <Text>Qty</Text>
                                    </View>
                                    <View style={[{ width: "50px", alignItems: "flex-end" }]}>
                                        <Text>Charge</Text>
                                    </View>
                                    {applyTax && (
                                        <View style={[{ width: "30px", alignItems: "flex-end" }]}>
                                            <Text>Tax</Text>
                                        </View>
                                    )}
                                    <View style={[{ width: "55px", alignItems: "flex-end" }]}>
                                        <Text>{applyTax ? "Subtotal" : "Total"}</Text>
                                    </View>
                                </View>
                            </View>
                            {items.map((item) => {
                                return (
                                    <InvoiceLineItem
                                        key={item.careResourceId}
                                        charge={item}
                                        taxRate={item.taxRate}
                                        applyTax={applyTax}
                                    />
                                );
                            })}
                        </View>
                    </View>
                </View>
            )}
        </View>
    );
};

export default InvoicePageContent;
